import { Component, Input, signal } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { Message } from '../interfaces/chat-clip-rep.interface';
import { AuthService } from '../../../../../../core/service/auth.service';
import { environment } from '../../../../../../../environments/environment';

@Component({
  selector: 'app-chat-message',
  standalone: true,
  imports: [CommonModule, DatePipe],
  template: `
    <div class="mb-2 sm:mb-3 lg:mb-4 flex" [class.justify-end]="isFromClient" [class.justify-start]="!isFromClient">
      <div class="max-w-[85%] sm:max-w-xs lg:max-w-md px-2 sm:px-3 lg:px-4 py-2 rounded-lg"
           [class]="messageClasses">

        @if (hasImage) {
          <div class="mb-2">
            <img [src]="imageUrl"
                 alt="Imagen del chat"
                 class="rounded-lg max-w-32 max-h-32 sm:max-w-40 sm:max-h-40 object-cover cursor-pointer hover:opacity-90 transition-opacity"
                 (click)="openImageModal(imageUrl)">
          </div>
        }

        <!-- Texto del mensaje -->
        @if (message.content && message.content.trim()) {
          <p class="text-xs sm:text-sm break-words">{{ message.content }}</p>
        }

        <!-- Hora -->
        <p class="text-xs mt-1 opacity-70">{{ message.timestamp | date:'short' }}</p>
      </div>
    </div>
  `
})export class ChatMessageComponent {
  @Input() message!: Message;
  idUser=signal(0)
constructor(private authService: AuthService){
this.idUser.set(this.authService.getUser()?.ua_id!)
}
  get isFromClient(): boolean {
    return this.message.senderId === this.idUser();
  }

  get messageClasses(): string {
    return this.isFromClient
      ? 'bg-yellow-500 text-white rounded-br-sm'
      : 'bg-gray-200 text-gray-800 rounded-bl-sm';
  }

  get hasImage(): boolean {
    // Detectar imagen por type 'IMAGE' o por presencia de fileName con mimeType de imagen
    const hasFileName = !!this.message.metadata?.fileName;
    const isImageType = this.message.type === 'IMAGE';
    const isImageMimeType = this.message.metadata?.mimeType?.startsWith('image/') || false;
    
    return hasFileName && (isImageType || isImageMimeType);
  }

  get imageUrl(): string {
    if (!this.message.metadata?.fileName) return '';
    
    // Si ya es una URL completa, devolverla tal como está
    if (this.message.metadata.fileName.startsWith('http')) {
      return this.message.metadata.fileName;
    }
    
    // Extraer solo el nombre del archivo (similar al patrón de referencia)
    const fileName = this.message.metadata.fileName.split('/').pop() || 
                    this.message.metadata.fileName.split('\\').pop() || 
                    this.message.metadata.fileName;
    
    // Construir la URL completa para descargar la imagen
    return `${environment.socketUrl}/image-loader/download/${fileName}`;
  }

  openImageModal(imageUrl: string) {
    // Por ahora solo console.log, después se puede implementar un modal
    // console.log('Abrir imagen:', imageUrl);
  }
}
